import { PayloadAction } from "@reduxjs/toolkit";
import { ICustomizeColumns, IPagination } from "app/types";
import { set } from "lodash";
import { createSlice } from "utils/@reduxjs/toolkit";
import {
  ISprintFilters,
  ISprintList,
  ISprints,
  updateFiledType,
} from "../types";
import { defaultSprintFormData, initialState } from "./initialState";

const useSprintSlice = createSlice({
  name: "sprintState",
  initialState,
  reducers: {
    toggleSettingDrawerOpen: (state, action: PayloadAction<boolean>) => {
      state.settingDrawerOpen = action.payload;
    },
    toggleSprintDetailsDrawer: (state, action: PayloadAction<boolean>) => {
      state.sprintDetailDrawer = action.payload;
    },
    setSelectedSprintId: (state, action: PayloadAction<string>) => {
      state.selectedSprintId = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setButtonLoading: (state, action: PayloadAction<boolean>) => {
      state.buttonLoading = action.payload;
    },
    setMainLoading: (state, action: PayloadAction<boolean>) => {
      state.mainLoading = action.payload;
    },
    setSprintFilters: (state, action: PayloadAction<ISprintFilters>) => {
      state.filters = action.payload;
    },
    setCustomizeTableHeader: (
      state,
      action: PayloadAction<Array<ICustomizeColumns>>,
    ) => {
      state.customizeHeader = action.payload?.sort((a, b) => a.order - b.order);
    },
    fetchSprintList: (state, action: PayloadAction<string>) => {
      if (!state.buttonLoading) {
        state.loading = true;
      }
    },
    fetchCompletedSprints: (state, action: PayloadAction<string>) => {
      if (!state.buttonLoading) {
        state.loading = true;
      }
    },

    setList: (state, action: PayloadAction<ISprintList[]>) => {
      if (state.pagination.page === 1) {
        state.list = action.payload;
      } else {
        state.list = [...state.list, ...action.payload];
      }
    },
    clearList: (state) => {
      state.list = [];
    },
    setCompletedSprintList: (state, action: PayloadAction<ISprintList[]>) => {
      state.completedSprintList = action.payload;
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
      state.pagination.page = 1;
    },
    setPagination: (state, action: PayloadAction<IPagination>) => {
      state.pagination = action.payload;
    },
    setCustomizeHeaderAllVisibility: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.customizeHeader.forEach((item) => {
        if (!item.disabled) {
          item.isVisible = action.payload;
        }
      });
    },
    setCustomizeHeaderOrder: (
      state,
      action: PayloadAction<ICustomizeColumns[]>,
    ) => {
      state.customizeHeader = action.payload;
    },

    setCustomizeHeader: (state, action: PayloadAction<string>) => {
      const index = state.customizeHeader.findIndex(
        (card) => card.type === action.payload,
      );
      if (index !== -1) {
        state.customizeHeader[index].isVisible =
          !state.customizeHeader[index].isVisible;
      }
    },
    updateCustomizeHeader: (
      state,
      action: PayloadAction<{ id: string; callback: () => void }>,
    ) => {
      state.buttonLoading = true;
    },

    updateFormErrors: (
      state,
      action: PayloadAction<{ key: string; value: any }>,
    ) => {
      set(state, `formData.${action.payload.key}`, action.payload.value);
    },
    updateFormValue: (
      state,
      action: PayloadAction<{ key: string; value: any }>,
    ) => {
      set(state, `formData.${action.payload.key}`, action.payload.value);
    },
    setSprintMembers: (state, action: PayloadAction<string[]>) => {
      state.formData.sprintMembers = action.payload;
    },
    createSprint: (
      state,
      action: PayloadAction<{ projectId: string; callback: () => void }>,
    ) => {
      state.buttonLoading = true;
    },
   
    updateSprint: (
      state,
      action: PayloadAction<{
        fieldUpdate: updateFiledType;
        id: string;
        callback: () => void;
      }>,
    ) => {
      state.buttonLoading = true;
    },
    updateSprintSuccess: (
      state,
      action: PayloadAction<{ id: string; changes: Partial<ISprintList> }>,
    ) => {
      const { id, changes } = action.payload;

      const index = state.list.findIndex((item) => item._id === id);
      if (index !== -1) {
        state.list[index] = {
          ...state.list[index],
          ...changes,
        };
      }

      state.buttonLoading = false;
    },
    updateSprintDeleteSuccess: (state, action: PayloadAction<string>) => {
      const id = action.payload;
      state.list = state.list.filter((item) => item._id !== id);
      state.buttonLoading = false;
    },

    clearSprintFormData: (state) => {
      state.formData = defaultSprintFormData;
    },
    removeAssignee: (
      state,
      action: PayloadAction<{ assigneeId: string }>,
    ) => {},
    // fetch customize cards
    fetchCustomizeCards: (state, action: PayloadAction<string>) => {
      state.mainLoading = true;
    },

    setSprintFiltersSearch: (state, action: PayloadAction<string>) => {
      state.filters.search = action.payload;
    },

  },
});

export const { reducer, actions, name: sliceKey } = useSprintSlice;
